import axios from "axios";
import { withSkipGlobalError } from "@/lib/http/skip-global-error";
import { editorHeaders } from "@/lib/sacred-library/sacred-library-api";
import { getApiBaseUrl } from "@/lib/api-base";

const API = getApiBaseUrl();

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export async function fetchJourneyProfile(token) {
  const res = await axios.get(`${API}/journey/profile`, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data?.journey;
}

export async function recomputeJourneyProfile(token, body = {}) {
  const res = await axios.post(`${API}/journey/profile`, body, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data?.journey;
}

export async function fetchJourneyToday(token) {
  const res = await axios.get(`${API}/journey/today`, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data;
}

export async function triggerJourneyRecompute(token) {
  const res = await axios.post(`${API}/journey/recompute`, {}, withSkipGlobalError({ headers: authHeaders(token) }));
  return res.data?.journey;
}

export async function fetchJourneyDebug(email) {
  const q = email ? `?email=${encodeURIComponent(email)}` : "";
  const res = await axios.get(`${API}/journey/debug${q}`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}

export async function fetchJourneyValidate(email) {
  const q = email ? `?email=${encodeURIComponent(email)}` : "";
  const res = await axios.get(`${API}/journey/validate${q}`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}

export async function adminJourneyRecompute(emailOrUserId, { email, user_id } = {}) {
  const body = email ? { email } : user_id ? { user_id } : { email: emailOrUserId };
  const res = await axios.post(
    `${API}/admin/journey/recompute`,
    body,
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data?.journey;
}

export async function adminJourneyOverride(email, overrides) {
  const res = await axios.post(
    `${API}/admin/journey/override`,
    { email, overrides },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data?.journey;
}

export async function fetchAdminJourneyLogs() {
  const res = await axios.get(`${API}/admin/journey/logs`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data?.logs ?? [];
}
